import React from "react";
import { useMsal } from "@azure/msal-react";
import { Button } from "devextreme-react";

/**
 * Renders a sign-out button
 */
export const SignOutButton: React.FC = () => {
    const { instance } = useMsal();

    const handleLogout = (logoutType: "popup" | "redirect") => {
        if (logoutType === "popup") {
            instance.logoutPopup({
                postLogoutRedirectUri: "/",
                mainWindowRedirectUri: "/"
            }).catch((e: Error) => {
                console.error(e.message);
            });
        } else if (logoutType === "redirect") {
            instance.logoutRedirect({
                postLogoutRedirectUri: "/",
            }).catch((e: Error) => {
                console.error(e.message);
            });
        }
    };

    return (
        <Button text="Logout" onClick={()=>handleLogout("redirect")} />
        // <DropdownButton variant="secondary" className="ml-auto" drop="start" title="Sign Out">
        //     <Dropdown.Item as="button" onClick={() => handleLogout("popup")}>
        //         Sign out using Popup
        //     </Dropdown.Item>
        //     <Dropdown.Item as="button" onClick={() => handleLogout("redirect")}>
        //         Sign out using Redirect
        //     </Dropdown.Item>
        // </DropdownButton>
    );
};
